import { render, staticRenderFns } from "./OrderChangeNewComponents.vue?vue&type=template&id=0e760c76&scoped=true&"
import script from "./OrderChangeNewComponents.vue?vue&type=script&lang=js&"
export * from "./OrderChangeNewComponents.vue?vue&type=script&lang=js&"
import style0 from "./OrderChangeNewComponents.vue?vue&type=style&index=0&id=0e760c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e760c76",
  null
  
)

export default component.exports